import { createAction } from '@reduxjs/toolkit'

export const roladPage = createAction<{isRefresh:boolean}>('puzzle/roladPage')
export const selectDexs = createAction<{dexs:Array<string> }>('griDexSwap/selectDex')

